"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close24"));
var _Download = _interopRequireDefault(require("@honeybook/icons/dist/icons/Download24"));
var _FilePlain = _interopRequireDefault(require("@honeybook/icons/dist/icons/FilePlain24"));
var _Image = _interopRequireDefault(require("@honeybook/icons/dist/icons/Image24"));
var _Download2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Download16"));
var _Trash = _interopRequireDefault(require("@honeybook/icons/dist/icons/Trash24"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _framerMotion = require("framer-motion");
var _variables = require("../../styles/variables");
var _reactUse = require("react-use");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBMediaElement = require("../HBMediaElement/HBMediaElement");
var _image = require("../common/image.utils");
var _reactDom = require("react-dom");
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _cloudinaryReact = require("cloudinary-react");
var _useWindowSize2 = require("../common/useWindowSize");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function getPDFImageSize(windowSizeData) {
  var isLargeUp = windowSizeData.isLargeUp,
    isMediumUp = windowSizeData.isMediumUp,
    windowSize = windowSizeData.windowSize;
  if (isLargeUp) {
    return {
      width: 670
    };
  }

  // in mobile/tablet we want coast to coast with padding on each side
  var padding = isMediumUp ? 80 : 20;
  var width = windowSize.width - padding * 2;
  return {
    width: width
  };
}
var PDFPreview = function PDFPreview(props) {
  var _getPDFImageSize = getPDFImageSize((0, _useWindowSize2.useWindowSize)()),
    width = _getPDFImageSize.width;
  var path = (0, _image.generatePdfPreviewUrl)({
    url: props.fileUrl,
    width: width
  });
  var Content = /*#__PURE__*/_react["default"].createElement("img", {
    src: path
  });
  return /*#__PURE__*/_react["default"].createElement(GenericPreview, (0, _extends2["default"])({}, props, {
    Content: Content,
    icon: _FilePlain["default"]
  }));
};
var ImagePreview = function ImagePreview(props) {
  var Content = (0, _image.isCloudinaryImage)(props.fileUrl) ? /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.CloudinaryContext, {
    secure: true,
    cloudName: "honeybook"
  }, /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Image, {
    publicId: props.cloudinaryPublicId || (0, _HBMediaElement.getCloudinaryPathFromCloudinaryUrl)(props.fileUrl),
    fetchFormat: "auto",
    quality: "auto",
    flags: "lossy",
    crop: "limit"
  })) : /*#__PURE__*/_react["default"].createElement("img", {
    src: props.fileUrl
  });
  return /*#__PURE__*/_react["default"].createElement(GenericPreview, (0, _extends2["default"])({}, props, {
    Content: Content,
    icon: _Image["default"]
  }));
};
var UnsupportedPreview = function UnsupportedPreview(props) {
  var onDownload = props.onDownload;
  return /*#__PURE__*/_react["default"].createElement(GenericPreview, (0, _extends2["default"])({}, props, {
    Content: /*#__PURE__*/_react["default"].createElement(UnsupportedMessage, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
      type: "title18",
      color: "textPrimary"
    }, "No preview available"), onDownload && /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
      onClick: onDownload,
      icon: /*#__PURE__*/_react["default"].createElement(_Download2["default"], null),
      buttonTheme: "primary",
      size: "sm",
      testIdName: "download"
    }, "Download")),
    icon: _FilePlain["default"]
  }));
};
var GenericPreview = function GenericPreview(_ref) {
  var onClose = _ref.onClose,
    onDownload = _ref.onDownload,
    onDelete = _ref.onDelete,
    fileName = _ref.fileName,
    Content = _ref.Content,
    Icon = _ref.icon;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var contentContainerRef = (0, _react.useRef)(null);
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMediumUp = _useWindowSize.isMediumUp;
  (0, _reactUse.useLockBodyScroll)(isShown);
  var onAnimationComplete = function onAnimationComplete() {
    if (!isShown) {
      onClose();
    }
  };
  (0, _react.useEffect)(function () {
    var contentContainer = contentContainerRef.current;
    var onKeyUp = function onKeyUp(ev) {
      if (ev.key === 'Escape') {
        ev.stopPropagation();
        setIsShown(false);
      }
    };
    var onBackdropClick = function onBackdropClick(ev) {
      if (ev.target === contentContainer) {
        setIsShown(false);
      }
    };
    if (isShown) {
      document.addEventListener('keyup', onKeyUp, true);
      contentContainer.addEventListener('click', onBackdropClick, true);
      return function () {
        document.removeEventListener('keyup', onKeyUp, true);
        contentContainer.removeEventListener('click', onBackdropClick, true);
      };
    }
  }, [isShown]);
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react["default"].createElement(Backdrop, {
    initial: {
      opacity: 0
    },
    animate: isShown ? {
      opacity: 1
    } : {
      opacity: 0
    },
    transition: transition,
    onAnimationComplete: onAnimationComplete
  }, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(FileDescription, null, /*#__PURE__*/_react["default"].createElement(Icon, {
    color: _colors["default"].white
  }), /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis18",
    color: "white",
    ellipsis: true
  }, fileName)), /*#__PURE__*/_react["default"].createElement(Actions, null, /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "light-invisible",
    icon: _Download["default"],
    label: "download",
    onClick: onDownload,
    size: "sm",
    testIdName: "download"
  }), !isMediumUp && onDelete && /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "light-invisible",
    icon: _Trash["default"],
    label: "delete",
    onClick: onDelete,
    size: "sm",
    testIdName: "delete"
  }), /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "light-invisible",
    icon: _Close["default"],
    label: "close",
    onClick: function onClick() {
      return setIsShown(false);
    },
    size: "sm",
    testIdName: "close"
  }))), /*#__PURE__*/_react["default"].createElement(ContentContainer, {
    ref: contentContainerRef
  }, Content))), document.body);
};
var HBFilePreview = function HBFilePreview(props) {
  if (props.fileType === 'image') {
    return /*#__PURE__*/_react["default"].createElement(ImagePreview, props);
  }
  var isPdf = (0, _image.isPdfUrl)(props.fileUrl);
  if (isPdf) {
    return /*#__PURE__*/_react["default"].createElement(PDFPreview, props);
  }
  return /*#__PURE__*/_react["default"].createElement(UnsupportedPreview, props);
};
var _default = exports["default"] = HBFilePreview;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBFilePreview__Container",
  componentId: "sc-zm3rqo-0"
})(["display:flex;flex-direction:column;padding:16px;box-sizing:border-box;height:100%;"]);
var ContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBFilePreview__ContentContainer",
  componentId: "sc-zm3rqo-1"
})(["justify-content:center;align-items:center;display:flex;padding-top:40px;&,*{height:100%;}img{object-fit:contain;max-width:100%;}"]);
var Header = _styledComponents["default"].div.withConfig({
  displayName: "HBFilePreview__Header",
  componentId: "sc-zm3rqo-2"
})(["display:flex;justify-content:space-between;position:absolute;gap:16px;padding:16px;inset:0 0 auto;background:linear-gradient( to bottom,rgba(0,0,0,0.65) 0,transparent 100% );"]);
var FileDescription = _styledComponents["default"].div.withConfig({
  displayName: "HBFilePreview__FileDescription",
  componentId: "sc-zm3rqo-3"
})(["display:flex;align-items:center;gap:12px;"]);
var Actions = _styledComponents["default"].div.withConfig({
  displayName: "HBFilePreview__Actions",
  componentId: "sc-zm3rqo-4"
})(["display:flex;"]);
var transition = {
  duration: 0.3,
  type: 'tween',
  ease: 'easeInOut'
};
var Backdrop = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBFilePreview__Backdrop",
  componentId: "sc-zm3rqo-5"
})(["position:fixed;z-index:", ";inset:0;background-color:", ";"], _variables.Z_INDEX.POPOVER, _colors["default"].black_07);
var UnsupportedMessage = _styledComponents["default"].div.withConfig({
  displayName: "HBFilePreview__UnsupportedMessage",
  componentId: "sc-zm3rqo-6"
})(["display:flex;width:382px;padding:24px;flex-direction:row;align-items:center;gap:24px;border-radius:4px;background:", ";&,*{height:auto;}button{height:36px;}"], _colors["default"].white);
//# sourceMappingURL=HBFilePreview.js.map